<!-- 注册页面 -->
<template>
  <div class="body-wrap">
    <div class="body-inner-wrap">
      <div class="body-top">
        <router-link tag="h2" class="pointer" to="/">校园精准服务系统</router-link>
        <p>
          已有账号，现在
          <router-link tag="a" to="/login">登录</router-link>
        </p>
      </div>
      <div class="find-title">
        <h2>找回密码</h2>
      </div>
      <div class="register-content">
        <div class="reg-inner-container" v-if="stepIndex == 1">
          <p class="find-info-tips">输入您的登录账号，以进行密码重设</p>
          <ul class="reg-form">
            <li class="reg-form-item" :class="{error: usernameerror != ''}">
              <input type="text" v-model="username" maxlength="18" placeholder="输入用户名" />
              <p class="error-info" v-if="usernameerror != ''">{{usernameerror}}</p>
            </li>
            <li class="reg-form-bottom">
              <button @click="next()">下一步</button>
            </li>
          </ul>
        </div>
        <div class="reg-inner-container" v-else>
          <ul class="find-form-2">
            <li class="find-form-item">
              <span class="form-title">您的账号</span>
              <div class="form-content">
                <span>{{username}}</span>
              </div>
            </li>
            <li class="find-form-item">
              <span class="form-title">关联手机号</span>
              <div class="form-content">
                <span>{{phone}}</span>
              </div>
            </li>
            <li class="find-form-item">
              <span class="form-title">图片验证码</span>
              <div class="form-content">
                <input type="text" v-model="imgcode" placeholder="请输入图片验证码" />
                <img :src="imgCodeUrl" @click="getNewCodeImgKey" alt="换一张" />
              </div>
              <span></span>
              <p class="error-info" v-if="imgcodeerror != ''">{{imgcodeerror}}</p>
            </li>
            <li class="find-form-item">
              <span class="form-title">短信验证码</span>
              <div class="form-content">
                <input type="text" v-model="msgcode" placeholder="请输入短信验证码" />
                <getCode
                  :phonenum="username"
                  :imgcode="imgcode"
                  :uuid="randomKey"
                  v-on:handleerror="handleerror"
                  type="15"
                  ref="code"
                  class="msgcode-wrap"
                ></getCode>
              </div>
              <span></span>
              <p class="error-info" v-if="msgcodeerror != ''">{{msgcodeerror}}</p>
            </li>
            <li class="find-form-item">
              <span class="form-title">新密码</span>
              <div class="form-content">
                <el-popover placement="right" width="300" trigger="click">
                  <ul class="ent-formtips-ul">
                    <li>6 - 18 个字符</li>
                    <li>只能包含英文字母、数字</li>
                    <li>必须同时包含字母、数字两种</li>
                  </ul>
                  <input
                    type="password"
                    v-model="password"
                    maxlength="18"
                    slot="reference"
                    placeholder="设定新密码"
                  />
                </el-popover>
              </div>
              <span></span>
              <p class="error-info" v-if="passworderror != ''">{{passworderror}}</p>
            </li>
            <li class="find-form-item">
              <span class="form-title">确认密码</span>
              <div class="form-content">
                <el-popover placement="right" width="300" trigger="click">
                  <ul class="ent-formtips-ul">
                    <li>再次输入设置的密码</li>
                  </ul>
                  <input
                    type="password"
                    v-model="repassword"
                    maxlength="18"
                    slot="reference"
                    placeholder="请重新输入密码"
                  />
                </el-popover>
              </div>
              <span></span>
              <p class="error-info" v-if="repassworderror != ''">{{repassworderror}}</p>
            </li>
          </ul>
          <div class="find-opr">
            <button class="normal" @click="prev()">上一步</button>
            <button class="pramiry" @click="submitreset">重置密码</button>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <my-footer></my-footer>
  </div>
</template>

<script>
import getCode from '@/components/getMsgCode/getMsgCode.vue'
import vFooter from '@/components/footer/footer.vue'
import {
  Popover
} from 'element-ui'

export default {
  name: 'register',
  components: {
    'my-footer': vFooter,
    'getCode': getCode,
    'el-popover': Popover
  },
  data () {
    return {
      username: '',
      phone: '',
      usernameerror: '',
      imgcode: '',
      imgcodeerror: '',
      msgcode: '',
      msgcodeerror: '',
      password: '',
      passworderror: '',
      repassword: '',
      repassworderror: '',
      stepIndex: 1,
      randomKey: this.getNewCodeImgKey(),
      imgCodeUrl: this.commonapi + '/captcha?uuid=' + this.randomKey
    }
  },
  created () {
    this.getNewCodeImgKey()
  },
  methods: {
    // 生成图片验证码Key
    getNewCodeImgKey () {
      // this.randomKey = Math.ceil(Math.random() * 1000) // 生成一个随机key（防止缓存)
      this.randomKey = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
      this.imgCodeUrl = this.commonapi + '/captcha?uuid=' + this.randomKey
    },
    submitreset () {
      let myreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/
      if (this.imgcode === '') {
        this.imgcodeerror = '请输入图片验证码'
        return false
      }
      this.imgcodeerror = ''
      if (this.msgcode === '') {
        this.msgcodeerror = '请输入短信验证码'
        return false
      }
      this.msgcodeerror = ''
      if (this.$refs.code.pinToken === '') {
        this.msgcodeerror = '请先获取短信验证码'
        return false
      }
      this.msgcodeerror = ''
      if (this.password === '') {
        this.passworderror = '新设定的密码不能为空'
        return false
      }
      this.passworderror = ''
      if (!new RegExp(myreg).test(this.password)) {
        this.passworderror = '输入的密码不符合规则'
        return false
      }
      this.passworderror = ''
      if (this.password !== this.repassword) {
        this.repassworderror = '两次密码输入不一致'
        return false
      }
      this.repassworderror = ''
      let data = {
        loginName: this.username,
        smsCode: this.msgcode,
        pinToken: this.$refs.code.pinToken,
        password: this.password
      }
      this.$http({
        method: 'POST',
        url: '/user/resetPwdByMobile',
        params: data
      }).then(res => {
        if (res.code === 100) {
          this.$message.success('密码已重置成功，请重新登录！')
          this.$router.push({ path: '/login' })
        } else {
          this.$alert(res.msg, '提示信息', { type: 'warning' })
          return false
        }
      }).catch(error => {
        console.log(error)
      })
    },
    prev () {
      this.stepIndex = 1
    },
    next () {
      if (this.username === '') {
        this.usernameerror = '请输入您要找回的用户名'
        return false
      }
      let data = {
        loginName: this.username
      }
      this.$http({
        method: 'POST',
        url: '/user/name/exist',
        params: data
      }).then(res => {
        if (res.code === 100) {
          this.usernameerror = ''
          this.phone = res.mobile
          this.stepIndex = 2
        } else {
          this.usernameerror = '用户不存在，请检查是否输入正确'
          return false
        }
      }).catch(error => {
        console.log(error)
      })
    },
    handleerror (msg, type) {
      this.msgcodeerror = msg
      if (type) {
        this.getNewCodeImgKey()
      }
    }
  }
}

</script>

<style src='./findpassword.scss' lang='scss' scoped></style>



// WEBPACK FOOTER //
// src/views/findpassword/findpassword.vue